var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('label',{staticClass:"input-label"},[_c('input',{attrs:{"name":_vm.testName,"type":"radio"},domProps:{"value":_vm.tests.class},on:{"change":_vm.emitTestPickerValue}}),_vm._v(" "+_vm._s(_vm.tests.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }